
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13198',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13198",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.726",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9940",
  "foundations-components": "static-1.8466",
  "foundations-components-legacy": "static-1.1491",
  "foundations-theming": "static-1.4755",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.87",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8315",
  "hub-http-shared-msw-handlers": "static-1.10588",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11771",
  "I18n": "static-7.1669",
  "jasmine-runner": "static-1.6735",
  "marketplace-discovery-studio-lib": "static-1.608",
  "marketplace-storefront-base": "static-1.13261",
  "quartz": "static-1.7435",
  "react-dlb": "static-1.88",
  "react-rhumb": "static-1.17002",
  "reactive-variable-buffer-atom": "static-1.3139",
  "reporting-testing-lib": "static-1.10695",
  "reselect": "static-3.10",
  "settings-ui-lib": "static-1.12807",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7604",
  "ui-addon-i18n": "static-1.11430",
  "ui-addon-react-router-dom": "static-1.9820",
  "unified-auth": "static-1.891",
  "unified-auth-core-lib": "static-1.1173",
  "usage-tracker": "static-1.7637",
  "usage-tracker-core": "static-1.7487",
  "customer-data-property-utils": "static-1.8385",
  "hub-http": "static-1.6497",
  "integrations-lib": "static-1.16996",
  "marketplace-ui-common": "static-1.20697",
  "marketplace-ui-install": "static-1.683",
  "property-management-iframe": "static-1.14102",
  "quartz-config": "static-1.1213",
  "quartz-core": "static-1.6654",
  "quartz-routing": "static-1.865",
  "quick-fetch": "static-1.4119",
  "react": "static-7.192",
  "rpc-client-utils": "static-1.4949",
  "ts-schema": "static-1.4281",
  "ui-universal-auth": "static-1.9377",
  "UIComponents": "static-3.8717",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3607",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3712",
  "quartz-webpack": "static-1.3659",
  "bend-plugin-quartz-routing": "static-1.513",
  "ai-components-ui-library": "static-1.9679",
  "codemirror": "static-5.100",
  "foundations-assets": "static-1.5166",
  "pulse": "static-1.912",
  "react-codemirror": "static-1.10923",
  "ui-extensions-preview-lib": "static-1.575",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4735",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2471",
  "framer-motion": "static-1.77",
  "hs-story-utils": "static-1.9708",
  "react-aria": "static-1.71",
  "react-create-root-preference": "static-1.68",
  "react-select-plus": "static-1.111",
  "react-utils": "static-2.5544",
  "react-virtualized": "static-2.105",
  "StyleGuideUI": "static-3.501",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2597",
  "ui-fonts": "static-1.1033",
  "ui-images": "static-2.1243",
  "bend-plugin-foundations-theming": "static-1.3238",
  "foundations-theming-base": "static-1.3740",
  "stylex": "static-1.39",
  "HeadJS": "static-2.794",
  "hs-test-utils-bend-plugin": "static-1.3426",
  "msw": "static-1.39",
  "testing-library": "static-1.157",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.89",
  "jasmine": "static-4.4597",
  "ui-addon-video-player": "static-1.8985",
  "ai-rendering-library": "static-1.11070",
  "chirp-fetch": "static-1.2177",
  "connections-embed-lib": "static-1.1486",
  "copilot-toolkit": "static-1.11822",
  "feedback-loader": "static-1.29784",
  "laboratory-lib": "static-3.7435",
  "marketplace-embed": "static-1.22874",
  "marketplace-ui-details": "static-1.10592",
  "marketplace-ui-reviews": "static-1.20652",
  "marketplace-ui-tracking": "static-1.14867",
  "sanitize-text": "static-1.8437",
  "usage-tracker-multi": "static-1.6051",
  "usage-tracker-session-replay": "static-1.5323",
  "wootric-nps": "static-1.7188",
  "quartz-head": "static-1.1100",
  "web-vitals": "static-1.13",
  "apollo-link-hub-http": "static-2.4939",
  "immer": "static-1.99",
  "immerable": "static-1.4432",
  "highcharts": "static-8.109",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2675",
  "reporting-data": "static-1.68762",
  "cssUtils": "static-1.904",
  "flux-actions": "static-1.366",
  "react-colorpicker": "static-2.10499",
  "react-dnd-compat": "static-1.4901",
  "redux-observable": "static-1.73",
  "ReduxMessenger": "static-2.10653",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7627",
  "icons": "static-2.680",
  "marketplace-ui-apps-core": "static-1.19229",
  "storybook-react": "static-1.38",
  "trellis-story-utils": "static-1.4792",
  "foundations-components-test-utils": "static-1.5949",
  "quartz-i18n": "static-1.1110",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.430",
  "ads-unified-auth-lib": "static-1.1268",
  "generic-oauth-auth-lib": "static-1.19",
  "google-sheets-integration-lib": "static-1.997",
  "microsoft-drive-auth-lib": "static-1.106",
  "surveymonkey-integration-lib": "static-1.443",
  "slack-ui-library": "static-1.10682",
  "fsm": "static-1.4032",
  "customer-data-objects": "static-1.7974",
  "property-translator": "static-1.5680",
  "hs-locale-management": "static-1.281",
  "frontend-preferences-client": "static-1.8206",
  "hs-promise-utils": "static-1.5879",
  "hubspot-apollo-client": "static-1.5161",
  "integrations-error-boundary-lib": "static-1.14411",
  "integrations-tracking-lib": "static-1.5891",
  "native-integrations-shared-strings": "static-1.8061",
  "sanitize": "static-1.4756",
  "superstore": "static-1.5039",
  "ui-shepherd-react": "static-3.10552",
  "ai-settings-ui-library": "static-1.8309",
  "hub-http-janus": "static-1.876",
  "hubspotter-http": "static-1.4852",
  "immutable-less": "static-1.4932",
  "marketplace-ui-client-types": "static-1.18104",
  "nav-meta": "static-1.30434",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18358",
  "ui-product-approvals-common": "static-1.997",
  "ai-studio-lib": "static-1.12423",
  "hubspot-prosemirror": "static-1.18938",
  "integrations-reconnect-lib": "static-1.459",
  "ui-addon-iframeable": "static-1.9360",
  "ui-addon-integrations-directory-panel": "static-2.8308",
  "ui-product-approvals": "static-1.29102",
  "ui-tool-access": "static-1.10438",
  "inbound-db-properties-service-client": "static-1.4044",
  "property-management-common": "static-1.6390",
  "opentelemetry-fe-types": "static-1.52",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.31",
  "opentelemetry-fe": "static-1.427",
  "quartz-auth": "static-1.1110",
  "quartz-test": "static-1.1110",
  "quartz-tracking": "static-1.814",
  "trellis-components": "static-1.2616",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.359",
  "HubStyle": "static-2.12078",
  "bender-build-tools": "static-1.3431",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22923",
  "ContentUtils": "static-1.69094",
  "customer-data-objects-ui-components": "static-1.13315",
  "sassPrefix": "static-1.175",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.415",
  "batch-promise": "static-1.1826",
  "event-emitter": "static-1.1236",
  "fast-json-patch": "static-1.68",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5741",
  "magpie-types": "static-1.5201",
  "stylex-utils": "static-1.138",
  "trellis-theming": "static-1.1258",
  "avatar-components": "static-1.2766",
  "breeze-engine-core": "static-1.964",
  "breeze-onboarding-components": "static-1.684",
  "customer-data-filters-ui": "static-1.40869",
  "customer-data-reference-ui-components": "static-1.13461",
  "embedded-academy-lib": "static-1.15476",
  "ExportDialog": "static-6.10660",
  "global-styles-ai-lib": "static-1.56",
  "highlight.js": "static-1.84",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42010",
  "reporting-snowflake": "static-1.57379",
  "reporting-ui-components": "static-2.66032",
  "reporting-visualizations": "static-1.60837",
  "trial-components-library": "static-1.14081",
  "ui-addon-teams": "static-1.21890",
  "upgrade-components-lib": "static-1.497",
  "navigation-components": "static-1.18797",
  "breeze-engine-lib": "static-1.1686",
  "simple-logging-lib": "static-1.3334",
  "fail-safe": "static-1.236",
  "app-governance-lib": "static-1.2360",
  "developer-experience-shared-components": "static-1.10787",
  "purchase-motions-components": "static-1.6340",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10189",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-public": "static-1.7448",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3983",
  "reference-resolvers": "static-1.8465",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4200",
  "hubspot-apollo-cache": "static-1.620",
  "universal-page-editor-lib": "static-1.3292",
  "final-form": "static-1.76",
  "redux-toolkit": "static-1.76",
  "simple-data-table": "static-1.3503",
  "atom": "static-1.5369",
  "merchandise-lib": "static-1.277",
  "salesImages": "static-1.546",
  "ui-addon-draggable": "static-3.5042",
  "content-assistance-lib": "static-1.8177",
  "content-media-capture": "static-1.5400",
  "customer-data-ui-utilities": "static-1.10112",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24453",
  "growth-payments-core": "static-1.26147",
  "knowledge-content-types": "static-1.8638",
  "PatternValidationJS": "static-1.3177",
  "payment-link-components": "static-1.24141",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20281",
  "ui-addon-emoji-picker": "static-1.10169",
  "ui-business-units-lib": "static-1.9371",
  "video-components-external": "static-1.12121",
  "video-data-lib": "static-1.35779",
  "navigation-messaging": "static-1.8124",
  "collaboration-sidebar": "static-1.58687",
  "crm-component-utils": "static-1.39802",
  "crm-properties-common-lib": "static-1.6173",
  "customer-data-properties": "static-1.52537",
  "external-options-client-types": "static-1.4327",
  "framework-data-schema-resolvers": "static-1.7176",
  "property-value-citations": "static-1.3151",
  "reference-resolvers-lite": "static-1.8385",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10586",
  "base-ui": "static-1.20",
  "react-day-picker": "static-1.8",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5097",
  "content-icons-ui": "static-1.2346",
  "idb-keyval": "static-1.49",
  "reactive-lib": "static-1.1002",
  "breeze-artifacts-sdk": "static-1.285",
  "onboarding-journeys-lib": "static-1.888",
  "onboarding-scopes": "static-1.6738",
  "conversations-skeleton-state": "static-1.7529",
  "crm-message-bus": "static-1.43726",
  "customer-data-filters-ui-msw-helpers": "static-1.23304",
  "events-data-lib": "static-1.527",
  "FormUrlGenerator": "static-2.5011",
  "framework-builder-read-service-client": "static-1.4209",
  "hs-resources": "static-1.475",
  "multi-account-reference-resolvers": "static-1.1286",
  "onboarding-tours": "static-1.17094",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14434",
  "academy-common-lib": "static-1.14936",
  "dashboard-lib": "static-1.82765",
  "getting-started-shared-tasks": "static-1.19204",
  "hubspot-prosemirror-plugins": "static-1.18930",
  "share-with-third-party-component-lib": "static-1.8988",
  "ui-asset-management-lib": "static-1.11381",
  "user-context": "static-1.5402",
  "reporting-plugins": "static-1.10726",
  "reporting-reports": "static-1.68439",
  "hubs-service-types": "static-1.1541",
  "purchase-motions-api": "static-1.6343",
  "signup-constants": "static-1.19597",
  "nest": "static-1.519",
  "breeze-engine-chat-components": "static-1.664",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.187",
  "framework-listing-lib": "static-2.29460",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31394",
  "apps-service-types": "static-1.4022",
  "oauth-service-types": "static-1.4521",
  "signup-ui-url-generator": "static-2.8344",
  "onboarding-tours-client": "static-1.5309",
  "one-click-checkout": "static-1.361",
  "platform-infra-nav-components": "static-1.7881",
  "subscription-experience-data-types": "static-1.15238",
  "crm-record-cards-service-types": "static-1.3775",
  "location-customization-utils-lib": "static-1.10065",
  "redux-thunk": "static-2.78",
  "react-flip-move": "static-1.76",
  "ui-coaching-tips": "static-1.29274",
  "content-media-composition-data-lib": "static-1.13204",
  "fix-webm-duration": "static-1.28",
  "notification-sounds": "static-1.4709",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.688",
  "ui-addon-opt": "static-4.8647",
  "commerce-tours-lib": "static-1.6591",
  "growth-onboarding-reliability": "static-1.5364",
  "sales-checkout-service-client": "static-1.3814",
  "data-token-picker": "static-1.16864",
  "FileManagerLib": "static-1.40093",
  "content-media-compositions": "static-2.17211",
  "media-bridge-lib": "static-1.19382",
  "chatspot-widget-iframe": "static-1.22914",
  "collaboration-sidebar-common": "static-1.3484",
  "marketing-platform-lib": "static-1.7154",
  "card-properties-lib": "static-1.44977",
  "commerce-subscription-lib": "static-1.37744",
  "crm-actions": "static-1.6635",
  "crm-cards-sdk": "static-1.44525",
  "customer-data-properties-shared-msw-handlers": "static-1.9915",
  "customer-data-tracking": "static-1.7165",
  "calling-global-api": "static-1.65555",
  "calling-internal-common": "static-1.31600",
  "calling-lifecycle-internal": "static-1.66937",
  "calling-lifecycle-messages": "static-1.59231",
  "commerce-products-lib": "static-1.10497",
  "conditional-properties-service-client": "static-1.4000",
  "crm-index-visualization-core": "static-1.4521",
  "crm-links": "static-1.6613",
  "crm-pipelines-api-client-types": "static-1.4335",
  "formula-editor": "static-1.14733",
  "google-libphonenumber": "static-1.43",
  "inbounddb-objects-service-types": "static-1.4414",
  "meetings-icalendar-utils-lib": "static-1.919",
  "multi-currency-client-types": "static-1.3896",
  "object-builder-ui-client": "static-1.49633",
  "pipeline-validation-client-types": "static-1.4169",
  "smart-data-capture-core": "static-1.110",
  "smart-property-lib": "static-1.8254",
  "tiered-pricing": "static-1.1927",
  "topics-actions-lib": "static-1.448",
  "ui-addon-form-validation": "static-1.11265",
  "zustand": "static-1.83",
  "fdsr-migration-layer": "static-1.295",
  "framework-data-schema-quick-fetch": "static-1.7081",
  "restore-request-side-panel-lib": "static-1.1636",
  "growth-data-modal": "static-1.5870",
  "growth-onboarding-confetti": "static-1.3344",
  "growth-onboarding-next-action-utils": "static-1.2656",
  "onboarding-tours-utils": "static-1.1161",
  "ui-shepherd-tracker": "static-1.7933",
  "academy-service-client": "static-1.3971",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39952",
  "SafeStorage": "static-1.4686",
  "video-embed": "static-1.36613",
  "redux-actions": "static-3.69",
  "EmailSignatureEditor": "static-1.24974",
  "viral-links-lib": "static-1.7359",
  "nested-table": "static-1.517",
  "timezone-utils": "static-2.5528",
  "getting-started-shared-tasks-store": "static-1.18322",
  "campaign-roi-lib": "static-1.10164",
  "campaigns-utils-lib": "static-1.3489",
  "ui-addon-calendars": "static-2.5613",
  "customer-data-views-management": "static-1.25992",
  "framework-data-table": "static-2.12518",
  "nudge-client-utils": "static-1.3130",
  "nudge-custom-ui-functions": "static-1.1466",
  "switchboard-lib": "static-1.499",
  "access-check-ui-lib": "static-1.1551",
  "app-users-service-client": "static-1.5902",
  "app-users-service-types": "static-1.5310",
  "mini-checkout-client": "static-1.27456",
  "onboarding-utils": "static-1.5648",
  "permissions-shared-i18n-strings-fe": "static-1.2119",
  "ui-coaching-tips-shared-config": "static-1.29259",
  "checkout-sdk": "static-3.24299",
  "payment-method-components": "static-1.7133",
  "touchless-buying-components": "static-1.6167",
  "upgrade-catalog-service-types": "static-1.3753",
  "edison-service-client-types": "static-1.675",
  "growth-onboarding-feedback-components": "static-1.6868",
  "audio-components": "static-1.6319",
  "FileManagerImages": "static-1.37604",
  "video-components": "static-1.14123",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92792",
  "customer-data-sidebar": "static-2.46706",
  "enrichment-lib": "static-1.301",
  "ui-addon-draggable-compat": "static-2.4548",
  "universal-record-utils-lib": "static-1.1853",
  "commerce-billing-lib": "static-1.20134",
  "commerce-shared-components-lib": "static-1.19192",
  "commerce-tools-ui-lib": "static-1.11013",
  "crm-fe-perf": "static-1.23186",
  "calling-error-reporting": "static-1.31607",
  "shared-worker-versioning": "static-1.11324",
  "calling-usage-tracker": "static-1.6820",
  "voice-sms-access-library": "static-1.1995",
  "commerce-permissions": "static-1.1060",
  "products-iframe-lib": "static-1.8560",
  "products-ui-components-shared-msw-handlers": "static-1.10970",
  "crm-index-associations-lib": "static-1.6725",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10671",
  "sales-views-client-types": "static-1.4539",
  "bark-lib": "static-1.16797",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.625",
  "policy-lib": "static-1.7084",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10734",
  "onboarding-data-sync-lib": "static-1.2484",
  "growth-onboarding-next-action-components": "static-1.2684",
  "user-context-client": "static-1.4791",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.59",
  "urlinator": "static-1.4815",
  "outpost": "static-1.4440",
  "draft-convert": "static-2.78",
  "draft-extend": "static-3.81",
  "draft-js": "static-5.83",
  "draft-plugins": "static-2.22133",
  "sales-email-signature-service-client": "static-1.4128",
  "ts-utils-lib": "static-1.433",
  "crm-export-dialog": "static-1.6565",
  "crm-view-components": "static-1.1080",
  "react-beautiful-dnd": "static-1.68",
  "customer-data-associations": "static-1.7610",
  "tasks-actions-lib": "static-1.91",
  "nudge-custom-function-registry": "static-1.2887",
  "nudge-renderer-utils": "static-1.3206",
  "whisper-core-api": "static-1.7293",
  "InboxConnectUtils": "static-4.15527",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46809",
  "hub-http-rxjs": "static-1.840",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4273",
  "company-details-components": "static-1.6485",
  "react-performance-metrics-lib": "static-1.837",
  "pricing-pages-ui-components": "static-1.15734",
  "quote-checkout-service-types": "static-1.3736",
  "social-insights-client-types": "static-1.22706",
  "crm_universal": "static-1.22474",
  "customer-data-email": "static-1.18502",
  "card-payment-highlight-lib": "static-1.37945",
  "commerce-contract-lib": "static-1.13278",
  "invoices-highlight-card-lib": "static-1.55689",
  "orders-highlight-card-lib": "static-1.22162",
  "products-highlight-card-lib": "static-1.18780",
  "quotes-highlight-card-lib": "static-1.72799",
  "crm-source-interpretation-lib": "static-1.5612",
  "data-agent-utils": "static-1.363",
  "crm-object-search-query-utilities": "static-1.10165",
  "utility-belt": "static-1.2816",
  "payments-enrollment-embed-lib": "static-1.23764",
  "stripe-embedded-components": "static-1.7973",
  "customer-data-rte": "static-1.33618",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6247",
  "payments-post-enroll-local-storage-lib": "static-1.5389",
  "qrcode-generator": "static-1.74",
  "quotes-client-types": "static-1.38889",
  "calling-orchestration-schema": "static-1.36772",
  "react-reducer-toolkit": "static-1.16333",
  "meetings-connect-utils-lib": "static-1.7891",
  "hub-http-contrib": "static-1.3322",
  "ui-addon-sales-email": "static-1.5495",
  "access-control-lib": "static-1.10719",
  "EmailComponents": "static-1.55516",
  "EmailData": "static-1.54194",
  "redux-less": "static-2.9762",
  "company-details-service-types": "static-1.4222",
  "segments-query-core": "static-1.1705",
  "pricing-pages-api": "static-1.15599",
  "sequences-lib": "static-1.8512",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.41015",
  "accounting-integrations-ui-components": "static-1.7512",
  "invoices-ui-lib": "static-1.55705",
  "commerce-products-api": "static-1.2672",
  "invoices-iframe-lib": "static-1.57763",
  "quotes-modal-lib": "static-1.103477",
  "quotes-ui-lib": "static-1.81520",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28877",
  "ContentComponents": "static-2.72050",
  "ContentData": "static-1.69169",
  "marketing-contacts-lib": "static-1.10984",
  "marketing-email-service-types": "static-1.2082",
  "messaging-editing-lib": "static-1.47098",
  "messaging-usage-based-billing-components-lib": "static-1.1960",
  "automation-ui-source-apps": "static-1.19653",
  "automation-ui-types": "static-1.20571",
  "messaging-types-lib": "static-1.46835",
  "onboarding-settings-client": "static-1.4791",
  "sequences-client-types-lib": "static-1.8369",
  "commerce-tax-lib": "static-1.820",
  "price-books-api": "static-1.1703",
  "price-books-components": "static-1.1761",
  "property-description-translator": "static-1.4123",
  "ramp-editor": "static-1.861",
  "commerce-analytics-service-client": "static-1.3802",
  "totals-ui-components": "static-1.24263",
  "SalesContentIndexUI": "static-3.9605",
  "advanced-menus-core": "static-1.15553",
  "advanced-menus-lib": "static-1.12429",
  "automation-ui-ubb": "static-1.6487",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7620",
  "data-token-views": "static-1.16845",
  "forms-utils-lib": "static-1.13070",
  "payments-embed-points-lib": "static-1.13561",
  "react-tinymce": "static-1.55945",
  "simple-menus-core": "static-1.15552",
  "simple-menus-lib": "static-1.17069",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55071",
  "tinymce-data": "static-1.41156",
  "tinymce-plugins": "static-1.58185",
  "tinymce-themes": "static-1.57041",
  "ui-brand-identity-lib": "static-1.16418",
  "ui-memberships-settings-lib": "static-1.34811",
  "videoconference-integration-components": "static-1.7244",
  "marketing-contacts-client": "static-1.7794",
  "mc-hard-limits-client-types": "static-1.188",
  "automation-applications-service-types": "static-1.3651",
  "automation-platform-service-types": "static-1.2662",
  "ContentEditorUI": "static-2.77871",
  "short-messages-app-service-client": "static-1.4197",
  "web-interactives-components": "static-1.14224",
  "web-interactives-data": "static-1.14225",
  "messaging-shared-utils-lib": "static-1.1409",
  "messaging-user-info-utils-lib": "static-1.1579",
  "email-portal-health-service-types": "static-1.1262",
  "line-items-api": "static-1.1074",
  "commerce-totals-service-types": "static-1.4020",
  "FireAlarmUi": "static-1.4708",
  "sales-templates-service-types-lib": "static-1.4373",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22507",
  "automation-ui-usage-tracking": "static-1.21970",
  "data-studio-ubb": "static-1.3478",
  "interframe": "static-3.5038",
  "layout-dnd-components": "static-1.12941",
  "layout-dnd-utils": "static-1.11916",
  "NamespacedHubStyle": "static-2.9251",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27622",
  "content-management-data-lib": "static-1.5930",
  "copilot-plugins": "static-1.11794",
  "cta-picker": "static-1.37053",
  "customer-agent-discovery-components-lib": "static-1.3886",
  "editor-components": "static-1.13626",
  "editor-iframe-lib": "static-1.8775",
  "error-messaging-js": "static-1.5480",
  "FormsCommonComponents": "static-1.86530",
  "layout-data-lib": "static-1.10241",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.71",
  "redux-request-state": "static-1.10932",
  "SharedLegalStrings": "static-1.2029",
  "smart-content-core": "static-1.43143",
  "smart-content-lib": "static-1.43796",
  "social-composer-lib": "static-1.60246",
  "structured-content-lib": "static-1.25886",
  "theme-previewer-lib": "static-1.53914",
  "tinymce-copilot": "static-1.17139",
  "xray-recommendation-lib": "static-1.8242",
  "automation-ui-routing": "static-1.21928",
  "sql-reporting-client-types": "static-1.5883",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42762",
  "reporting-enablement": "static-1.23798",
  "forms-ai-lib": "static-1.4739",
  "codemirror-dlb": "static-1.59430",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6721",
  "report-customization-components": "static-1.13880",
  "data-quality-ui-library": "static-1.13765",
  "reporting-filters": "static-1.975",
  "reporting-insights-lib": "static-1.2538",
  "segments-client-types": "static-1.11472"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13198",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.726",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9940",
  "foundations-components": "/foundations-components/static-1.8466",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1491",
  "foundations-theming": "/foundations-theming/static-1.4755",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.87",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8315",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10588",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11771",
  "I18n": "/I18n/static-7.1669",
  "jasmine-runner": "/jasmine-runner/static-1.6735",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.608",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13261",
  "quartz": "/quartz/static-1.7435",
  "react-dlb": "/react-dlb/static-1.88",
  "react-rhumb": "/react-rhumb/static-1.17002",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3139",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10695",
  "reselect": "/reselect/static-3.10",
  "settings-ui-lib": "/settings-ui-lib/static-1.12807",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7604",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11430",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9820",
  "unified-auth": "/unified-auth/static-1.891",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1173",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8385",
  "hub-http": "/hub-http/static-1.6497",
  "integrations-lib": "/integrations-lib/static-1.16996",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20697",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.683",
  "property-management-iframe": "/property-management-iframe/static-1.14102",
  "quartz-config": "/quartz-config/static-1.1213",
  "quartz-core": "/quartz-core/static-1.6654",
  "quartz-routing": "/quartz-routing/static-1.865",
  "quick-fetch": "/quick-fetch/static-1.4119",
  "react": "/react/static-7.192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4949",
  "ts-schema": "/ts-schema/static-1.4281",
  "ui-universal-auth": "/ui-universal-auth/static-1.9377",
  "UIComponents": "/UIComponents/static-3.8717",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3607",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3712",
  "quartz-webpack": "/quartz-webpack/static-1.3659",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.513",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9679",
  "codemirror": "/codemirror/static-5.100",
  "foundations-assets": "/foundations-assets/static-1.5166",
  "pulse": "/pulse/static-1.912",
  "react-codemirror": "/react-codemirror/static-1.10923",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.575",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4735",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2471",
  "framer-motion": "/framer-motion/static-1.77",
  "hs-story-utils": "/hs-story-utils/static-1.9708",
  "react-aria": "/react-aria/static-1.71",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "react-select-plus": "/react-select-plus/static-1.111",
  "react-utils": "/react-utils/static-2.5544",
  "react-virtualized": "/react-virtualized/static-2.105",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2597",
  "ui-fonts": "/ui-fonts/static-1.1033",
  "ui-images": "/ui-images/static-2.1243",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3238",
  "foundations-theming-base": "/foundations-theming-base/static-1.3740",
  "stylex": "/stylex/static-1.39",
  "HeadJS": "/HeadJS/static-2.794",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3426",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.157",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.89",
  "jasmine": "/jasmine/static-4.4597",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8985",
  "ai-rendering-library": "/ai-rendering-library/static-1.11070",
  "chirp-fetch": "/chirp-fetch/static-1.2177",
  "connections-embed-lib": "/connections-embed-lib/static-1.1486",
  "copilot-toolkit": "/copilot-toolkit/static-1.11822",
  "feedback-loader": "/feedback-loader/static-1.29784",
  "laboratory-lib": "/laboratory-lib/static-3.7435",
  "marketplace-embed": "/marketplace-embed/static-1.22874",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10592",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20652",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14867",
  "sanitize-text": "/sanitize-text/static-1.8437",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "wootric-nps": "/wootric-nps/static-1.7188",
  "quartz-head": "/quartz-head/static-1.1100",
  "web-vitals": "/web-vitals/static-1.13",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4939",
  "immer": "/immer/static-1.99",
  "immerable": "/immerable/static-1.4432",
  "highcharts": "/highcharts/static-8.109",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2675",
  "reporting-data": "/reporting-data/static-1.68762",
  "cssUtils": "/cssUtils/static-1.904",
  "flux-actions": "/flux-actions/static-1.366",
  "react-colorpicker": "/react-colorpicker/static-2.10499",
  "react-dnd-compat": "/react-dnd-compat/static-1.4901",
  "redux-observable": "/redux-observable/static-1.73",
  "ReduxMessenger": "/ReduxMessenger/static-2.10653",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "icons": "/icons/static-2.680",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19229",
  "storybook-react": "/storybook-react/static-1.38",
  "trellis-story-utils": "/trellis-story-utils/static-1.4792",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5949",
  "quartz-i18n": "/quartz-i18n/static-1.1110",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.430",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1268",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.19",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.997",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.106",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.443",
  "slack-ui-library": "/slack-ui-library/static-1.10682",
  "fsm": "/fsm/static-1.4032",
  "customer-data-objects": "/customer-data-objects/static-1.7974",
  "property-translator": "/property-translator/static-1.5680",
  "hs-locale-management": "/hs-locale-management/static-1.281",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8206",
  "hs-promise-utils": "/hs-promise-utils/static-1.5879",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5161",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14411",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5891",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8061",
  "sanitize": "/sanitize/static-1.4756",
  "superstore": "/superstore/static-1.5039",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10552",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8309",
  "hub-http-janus": "/hub-http-janus/static-1.876",
  "hubspotter-http": "/hubspotter-http/static-1.4852",
  "immutable-less": "/immutable-less/static-1.4932",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18104",
  "nav-meta": "/nav-meta/static-1.30434",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18358",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.997",
  "ai-studio-lib": "/ai-studio-lib/static-1.12423",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18938",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.459",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9360",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8308",
  "ui-product-approvals": "/ui-product-approvals/static-1.29102",
  "ui-tool-access": "/ui-tool-access/static-1.10438",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4044",
  "property-management-common": "/property-management-common/static-1.6390",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.52",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.31",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.427",
  "quartz-auth": "/quartz-auth/static-1.1110",
  "quartz-test": "/quartz-test/static-1.1110",
  "quartz-tracking": "/quartz-tracking/static-1.814",
  "trellis-components": "/trellis-components/static-1.2616",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.359",
  "HubStyle": "/HubStyle/static-2.12078",
  "bender-build-tools": "/bender-build-tools/static-1.3431",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22923",
  "ContentUtils": "/ContentUtils/static-1.69094",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13315",
  "sassPrefix": "/sassPrefix/static-1.175",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.415",
  "batch-promise": "/batch-promise/static-1.1826",
  "event-emitter": "/event-emitter/static-1.1236",
  "fast-json-patch": "/fast-json-patch/static-1.68",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5741",
  "magpie-types": "/magpie-types/static-1.5201",
  "stylex-utils": "/stylex-utils/static-1.138",
  "trellis-theming": "/trellis-theming/static-1.1258",
  "avatar-components": "/avatar-components/static-1.2766",
  "breeze-engine-core": "/breeze-engine-core/static-1.964",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.684",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40869",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13461",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15476",
  "ExportDialog": "/ExportDialog/static-6.10660",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.56",
  "highlight.js": "/highlight.js/static-1.84",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42010",
  "reporting-snowflake": "/reporting-snowflake/static-1.57379",
  "reporting-ui-components": "/reporting-ui-components/static-2.66032",
  "reporting-visualizations": "/reporting-visualizations/static-1.60837",
  "trial-components-library": "/trial-components-library/static-1.14081",
  "ui-addon-teams": "/ui-addon-teams/static-1.21890",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.497",
  "navigation-components": "/navigation-components/static-1.18797",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1686",
  "simple-logging-lib": "/simple-logging-lib/static-1.3334",
  "fail-safe": "/fail-safe/static-1.236",
  "app-governance-lib": "/app-governance-lib/static-1.2360",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10787",
  "purchase-motions-components": "/purchase-motions-components/static-1.6340",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10189",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-public": "/usage-tracker-public/static-1.7448",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3983",
  "reference-resolvers": "/reference-resolvers/static-1.8465",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4200",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.620",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3292",
  "final-form": "/final-form/static-1.76",
  "redux-toolkit": "/redux-toolkit/static-1.76",
  "simple-data-table": "/simple-data-table/static-1.3503",
  "atom": "/atom/static-1.5369",
  "merchandise-lib": "/merchandise-lib/static-1.277",
  "salesImages": "/salesImages/static-1.546",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5042",
  "content-assistance-lib": "/content-assistance-lib/static-1.8177",
  "content-media-capture": "/content-media-capture/static-1.5400",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10112",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24453",
  "growth-payments-core": "/growth-payments-core/static-1.26147",
  "knowledge-content-types": "/knowledge-content-types/static-1.8638",
  "PatternValidationJS": "/PatternValidationJS/static-1.3177",
  "payment-link-components": "/payment-link-components/static-1.24141",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20281",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10169",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9371",
  "video-components-external": "/video-components-external/static-1.12121",
  "video-data-lib": "/video-data-lib/static-1.35779",
  "navigation-messaging": "/navigation-messaging/static-1.8124",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58687",
  "crm-component-utils": "/crm-component-utils/static-1.39802",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6173",
  "customer-data-properties": "/customer-data-properties/static-1.52537",
  "external-options-client-types": "/external-options-client-types/static-1.4327",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7176",
  "property-value-citations": "/property-value-citations/static-1.3151",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8385",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10586",
  "base-ui": "/base-ui/static-1.20",
  "react-day-picker": "/react-day-picker/static-1.8",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5097",
  "content-icons-ui": "/content-icons-ui/static-1.2346",
  "idb-keyval": "/idb-keyval/static-1.49",
  "reactive-lib": "/reactive-lib/static-1.1002",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.285",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.888",
  "onboarding-scopes": "/onboarding-scopes/static-1.6738",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7529",
  "crm-message-bus": "/crm-message-bus/static-1.43726",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23304",
  "events-data-lib": "/events-data-lib/static-1.527",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5011",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4209",
  "hs-resources": "/hs-resources/static-1.475",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1286",
  "onboarding-tours": "/onboarding-tours/static-1.17094",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14434",
  "academy-common-lib": "/academy-common-lib/static-1.14936",
  "dashboard-lib": "/dashboard-lib/static-1.82765",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19204",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18930",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8988",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11381",
  "user-context": "/user-context/static-1.5402",
  "reporting-plugins": "/reporting-plugins/static-1.10726",
  "reporting-reports": "/reporting-reports/static-1.68439",
  "hubs-service-types": "/hubs-service-types/static-1.1541",
  "purchase-motions-api": "/purchase-motions-api/static-1.6343",
  "signup-constants": "/signup-constants/static-1.19597",
  "nest": "/nest/static-1.519",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.664",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.187",
  "framework-listing-lib": "/framework-listing-lib/static-2.29460",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31394",
  "apps-service-types": "/apps-service-types/static-1.4022",
  "oauth-service-types": "/oauth-service-types/static-1.4521",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8344",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5309",
  "one-click-checkout": "/one-click-checkout/static-1.361",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7881",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15238",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3775",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10065",
  "redux-thunk": "/redux-thunk/static-2.78",
  "react-flip-move": "/react-flip-move/static-1.76",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29274",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13204",
  "fix-webm-duration": "/fix-webm-duration/static-1.28",
  "notification-sounds": "/notification-sounds/static-1.4709",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.688",
  "ui-addon-opt": "/ui-addon-opt/static-4.8647",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6591",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5364",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3814",
  "data-token-picker": "/data-token-picker/static-1.16864",
  "FileManagerLib": "/FileManagerLib/static-1.40093",
  "content-media-compositions": "/content-media-compositions/static-2.17211",
  "media-bridge-lib": "/media-bridge-lib/static-1.19382",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22914",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3484",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7154",
  "card-properties-lib": "/card-properties-lib/static-1.44977",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37744",
  "crm-actions": "/crm-actions/static-1.6635",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44525",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9915",
  "customer-data-tracking": "/customer-data-tracking/static-1.7165",
  "calling-global-api": "/calling-global-api/static-1.65555",
  "calling-internal-common": "/calling-internal-common/static-1.31600",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66937",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59231",
  "commerce-products-lib": "/commerce-products-lib/static-1.10497",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4000",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4521",
  "crm-links": "/crm-links/static-1.6613",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4335",
  "formula-editor": "/formula-editor/static-1.14733",
  "google-libphonenumber": "/google-libphonenumber/static-1.43",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4414",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.919",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3896",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49633",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4169",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.110",
  "smart-property-lib": "/smart-property-lib/static-1.8254",
  "tiered-pricing": "/tiered-pricing/static-1.1927",
  "topics-actions-lib": "/topics-actions-lib/static-1.448",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11265",
  "zustand": "/zustand/static-1.83",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.295",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7081",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1636",
  "growth-data-modal": "/growth-data-modal/static-1.5870",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3344",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2656",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1161",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7933",
  "academy-service-client": "/academy-service-client/static-1.3971",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39952",
  "SafeStorage": "/SafeStorage/static-1.4686",
  "video-embed": "/video-embed/static-1.36613",
  "redux-actions": "/redux-actions/static-3.69",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24974",
  "viral-links-lib": "/viral-links-lib/static-1.7359",
  "nested-table": "/nested-table/static-1.517",
  "timezone-utils": "/timezone-utils/static-2.5528",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18322",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10164",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3489",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5613",
  "customer-data-views-management": "/customer-data-views-management/static-1.25992",
  "framework-data-table": "/framework-data-table/static-2.12518",
  "nudge-client-utils": "/nudge-client-utils/static-1.3130",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1466",
  "switchboard-lib": "/switchboard-lib/static-1.499",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1551",
  "app-users-service-client": "/app-users-service-client/static-1.5902",
  "app-users-service-types": "/app-users-service-types/static-1.5310",
  "mini-checkout-client": "/mini-checkout-client/static-1.27456",
  "onboarding-utils": "/onboarding-utils/static-1.5648",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2119",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29259",
  "checkout-sdk": "/checkout-sdk/static-3.24299",
  "payment-method-components": "/payment-method-components/static-1.7133",
  "touchless-buying-components": "/touchless-buying-components/static-1.6167",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3753",
  "edison-service-client-types": "/edison-service-client-types/static-1.675",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6868",
  "audio-components": "/audio-components/static-1.6319",
  "FileManagerImages": "/FileManagerImages/static-1.37604",
  "video-components": "/video-components/static-1.14123",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92792",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46706",
  "enrichment-lib": "/enrichment-lib/static-1.301",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4548",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1853",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20134",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19192",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11013",
  "crm-fe-perf": "/crm-fe-perf/static-1.23186",
  "calling-error-reporting": "/calling-error-reporting/static-1.31607",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11324",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6820",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1995",
  "commerce-permissions": "/commerce-permissions/static-1.1060",
  "products-iframe-lib": "/products-iframe-lib/static-1.8560",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10970",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6725",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10671",
  "sales-views-client-types": "/sales-views-client-types/static-1.4539",
  "bark-lib": "/bark-lib/static-1.16797",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.625",
  "policy-lib": "/policy-lib/static-1.7084",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10734",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2484",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2684",
  "user-context-client": "/user-context-client/static-1.4791",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.59",
  "urlinator": "/urlinator/static-1.4815",
  "outpost": "/outpost/static-1.4440",
  "draft-convert": "/draft-convert/static-2.78",
  "draft-extend": "/draft-extend/static-3.81",
  "draft-js": "/draft-js/static-5.83",
  "draft-plugins": "/draft-plugins/static-2.22133",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4128",
  "ts-utils-lib": "/ts-utils-lib/static-1.433",
  "crm-export-dialog": "/crm-export-dialog/static-1.6565",
  "crm-view-components": "/crm-view-components/static-1.1080",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.68",
  "customer-data-associations": "/customer-data-associations/static-1.7610",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.91",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2887",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3206",
  "whisper-core-api": "/whisper-core-api/static-1.7293",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15527",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46809",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.840",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4273",
  "company-details-components": "/company-details-components/static-1.6485",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.837",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15734",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3736",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "crm_universal": "/crm_universal/static-1.22474",
  "customer-data-email": "/customer-data-email/static-1.18502",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37945",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13278",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55689",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22162",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18780",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72799",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5612",
  "data-agent-utils": "/data-agent-utils/static-1.363",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10165",
  "utility-belt": "/utility-belt/static-1.2816",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23764",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7973",
  "customer-data-rte": "/customer-data-rte/static-1.33618",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6247",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5389",
  "qrcode-generator": "/qrcode-generator/static-1.74",
  "quotes-client-types": "/quotes-client-types/static-1.38889",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36772",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16333",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7891",
  "hub-http-contrib": "/hub-http-contrib/static-1.3322",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5495",
  "access-control-lib": "/access-control-lib/static-1.10719",
  "EmailComponents": "/EmailComponents/static-1.55516",
  "EmailData": "/EmailData/static-1.54194",
  "redux-less": "/redux-less/static-2.9762",
  "company-details-service-types": "/company-details-service-types/static-1.4222",
  "segments-query-core": "/segments-query-core/static-1.1705",
  "pricing-pages-api": "/pricing-pages-api/static-1.15599",
  "sequences-lib": "/sequences-lib/static-1.8512",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.41015",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7512",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55705",
  "commerce-products-api": "/commerce-products-api/static-1.2672",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57763",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103477",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81520",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28877",
  "ContentComponents": "/ContentComponents/static-2.72050",
  "ContentData": "/ContentData/static-1.69169",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10984",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2082",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47098",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1960",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19653",
  "automation-ui-types": "/automation-ui-types/static-1.20571",
  "messaging-types-lib": "/messaging-types-lib/static-1.46835",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4791",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8369",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.820",
  "price-books-api": "/price-books-api/static-1.1703",
  "price-books-components": "/price-books-components/static-1.1761",
  "property-description-translator": "/property-description-translator/static-1.4123",
  "ramp-editor": "/ramp-editor/static-1.861",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3802",
  "totals-ui-components": "/totals-ui-components/static-1.24263",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9605",
  "advanced-menus-core": "/advanced-menus-core/static-1.15553",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12429",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6487",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7620",
  "data-token-views": "/data-token-views/static-1.16845",
  "forms-utils-lib": "/forms-utils-lib/static-1.13070",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13561",
  "react-tinymce": "/react-tinymce/static-1.55945",
  "simple-menus-core": "/simple-menus-core/static-1.15552",
  "simple-menus-lib": "/simple-menus-lib/static-1.17069",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55071",
  "tinymce-data": "/tinymce-data/static-1.41156",
  "tinymce-plugins": "/tinymce-plugins/static-1.58185",
  "tinymce-themes": "/tinymce-themes/static-1.57041",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16418",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34811",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7244",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7794",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.188",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3651",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2662",
  "ContentEditorUI": "/ContentEditorUI/static-2.77871",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4197",
  "web-interactives-components": "/web-interactives-components/static-1.14224",
  "web-interactives-data": "/web-interactives-data/static-1.14225",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1409",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1579",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1262",
  "line-items-api": "/line-items-api/static-1.1074",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4020",
  "FireAlarmUi": "/FireAlarmUi/static-1.4708",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4373",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22507",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21970",
  "data-studio-ubb": "/data-studio-ubb/static-1.3478",
  "interframe": "/interframe/static-3.5038",
  "layout-dnd-components": "/layout-dnd-components/static-1.12941",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11916",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9251",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27622",
  "content-management-data-lib": "/content-management-data-lib/static-1.5930",
  "copilot-plugins": "/copilot-plugins/static-1.11794",
  "cta-picker": "/cta-picker/static-1.37053",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3886",
  "editor-components": "/editor-components/static-1.13626",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8775",
  "error-messaging-js": "/error-messaging-js/static-1.5480",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86530",
  "layout-data-lib": "/layout-data-lib/static-1.10241",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.71",
  "redux-request-state": "/redux-request-state/static-1.10932",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2029",
  "smart-content-core": "/smart-content-core/static-1.43143",
  "smart-content-lib": "/smart-content-lib/static-1.43796",
  "social-composer-lib": "/social-composer-lib/static-1.60246",
  "structured-content-lib": "/structured-content-lib/static-1.25886",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53914",
  "tinymce-copilot": "/tinymce-copilot/static-1.17139",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8242",
  "automation-ui-routing": "/automation-ui-routing/static-1.21928",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5883",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42762",
  "reporting-enablement": "/reporting-enablement/static-1.23798",
  "forms-ai-lib": "/forms-ai-lib/static-1.4739",
  "codemirror-dlb": "/codemirror-dlb/static-1.59430",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6721",
  "report-customization-components": "/report-customization-components/static-1.13880",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13765",
  "reporting-filters": "/reporting-filters/static-1.975",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2538",
  "segments-client-types": "/segments-client-types/static-1.11472"
}
};
